import { useEffect, useState } from "react";
import api from "../utils/api"; // 🔥 ekledik

const ENDPOINT_VIDEO_CONSUMPTION_YESTERDAY = "/videoconsumption/yesterday";
const ENDPOINT_SWITCHIN_YESTERDAY = "/switchin/yesterday";
const ENDPOINT_UNIQUE_YESTERDAY = "/unique/yesterday";

async function fetchValue(url, signal) {
  const res = await api.get(url, {
    signal, // 🔥 abort desteği
  });

  // backend contract: { value: number }
  return Number(res.data?.value ?? 0) || 0;
}

export function useOverviewKpis(channelId) {
  const [videoConsumedYesterday, setVideoConsumedYesterday] = useState(0);
  const [switchInYesterday, setSwitchInYesterday] = useState(0);
  const [uniqueTvYesterday, setUniqueTvYesterday] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!channelId) return;

    const controller = new AbortController();

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const [vc, sw, un] = await Promise.all([
          fetchValue(
            `${ENDPOINT_VIDEO_CONSUMPTION_YESTERDAY}?c=${encodeURIComponent(channelId)}`,
            controller.signal
          ),
          fetchValue(
            `${ENDPOINT_SWITCHIN_YESTERDAY}?c=${encodeURIComponent(channelId)}`,
            controller.signal
          ),
          fetchValue(
            `${ENDPOINT_UNIQUE_YESTERDAY}?c=${encodeURIComponent(channelId)}`,
            controller.signal
          ),
        ]);

        setVideoConsumedYesterday(vc);
        setSwitchInYesterday(sw);
        setUniqueTvYesterday(un);
      } catch (e) {
        if (e?.name !== "CanceledError") { // 🔥 axios cancel
          console.error("useOverviewKpis error:", e);
          setError(e);
        }
      } finally {
        setLoading(false);
      }
    }

    load();

    return () => controller.abort();
  }, [channelId]);

  return {
    videoConsumedYesterday,
    switchInYesterday,
    uniqueTvYesterday,
    loading,
    error,
  };
}